import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../Components/Button/CustomButton";
import { handleAddPolicy } from "../../../APIs/Function/Policy/AddPolicy";
import { GetPolicy } from "../../../APIs/Function/Policy/GetPolicy";

const Policy = () => {
  const [loading, setLoading] = useState(false);

  const handleDragStart = (event) => {
    event.preventDefault();
  };
  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "list",
    "bullet",
    "link",
  ];
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      policy: "",
    },
    validationSchema: Yup.object({
      policy: Yup.string().required("Policy Is Required"),
    }),

    onSubmit: async (values, { resetForm }) => {
        try {
          
          const trimmedPolicy = values.policy.trim();
      
          if (!trimmedPolicy || trimmedPolicy === '<p><br></p>') {
            alert("Policy cannot be empty");
            return; 
          }
          setLoading(true);
          let res = await handleAddPolicy(values);
          if (res.s) {
            alert("Privacy Policy Updated Successfully");
          }
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      },
      
      
      
  });

  const handlePolicy = async () => {
    try {
      let res = await GetPolicy();
      if (res.s) {
        console.log(res.r.data);
        formik.setFieldValue("policy", res.r.privacy_policy);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handlePolicy();
  }, []);

  return (
    <Box>
      <Box
        sx={{
          width: "95%",
          m: "auto",
          textAlign: "left",
          borderRadius: "10px",
          boxSizing: "border-box",
          p: "2px",
          mt: "15px",
          "& .ql-container": {
            minHeight: "200px",
            maxHeight: "80vh",
            overflow: "auto",
            resize: "both",
            backgroundColor: "transparent",
            color: "#000",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            // border: "none",
            backgroundColor: "#fff",
          },
          "& .ql-toolbar": {
            // borderTop: "none",
            // borderLeft: "none",
            // borderRight: "none",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            zIndex: 999,
            backgroundColor: "#fff",
          },
        }}
      >
        <ReactQuill
          name="policy"
          style={{
            width: "100%",
            textAlign: "left",
            borderRadius: "15px",
          }}
          formats={formats}
          onDragStart={handleDragStart}
          theme="snow"
          onChange={(e) => {
            formik.setFieldValue("policy", e);
          }}
          value={formik.values.policy}
          modules={{
            toolbar: {
              container: [
                [{ header: "1" }, { header: "2" }],
                [{ font: [] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
                ["clean"],
              ],
            },
          }}
        />
      </Box>

      <Box
        sx={{
          width: "97%",
          display: "flex",
          justifyContent: "end",
          mt: "10px",
        }}
      >
        <CustomButton
          disabled={!(formik.dirty && formik.isValid)}
          onClick={formik.handleSubmit}
          sx={{
            width: "20%",
            "&:disabled": {
              color: "#fff",
              bgcolor: "gray",
            },
          }}
        >
          Submit
        </CustomButton>
      </Box>
    </Box>
  );
};

export default Policy;
